import { Grid } from "@mui/material";

interface LayoutContainerProps {
    children: JSX.Element
}

const LayoutContainer: React.FC<LayoutContainerProps> = ({
    children
}) => (
    <Grid 
        container
        gap={2}   
        style={{ 
        backgroundColor: "white", 
        borderRadius: '1rem', 
        padding: "1rem", 
        border: ".5px solid #e0e0e0"
      }}>
        {children}
    </Grid>
  );

export default LayoutContainer